export enum ContactType {
	CALL = 'CALL',
	VOICE_MESSAGE = 'VOICE_MESSAGE',
	SMS = 'SMS',
	EMAIL = 'EMAIL',
	AGENCY_VISIT = 'AGENCY_VISIT',
}

export enum LastContactMode {
	PROFILE = 'PROFILE',
	COMPANY_NEED = 'COMPANY_NEED',
}

export interface LastContactModalBaseProps {
	open: boolean;
	workerIds: string[];
	title?: string;
	onSuccess?: (payload?: SaveLastContactPayload) => void | Promise<void>;
	onCancel?: () => void;
}

export interface LastContactModalProfileProps
	extends LastContactModalBaseProps {
	mode: LastContactMode.PROFILE;
}

export interface LastContactModalCompanyNeedProps
	extends LastContactModalBaseProps {
	mode: LastContactMode.COMPANY_NEED;
	companyNeedId: string;
	companyNeedCreatedAt?: string;
}

export type LastContactModalProps =
	| LastContactModalProfileProps
	| LastContactModalCompanyNeedProps;

export interface SaveLastContactPayload {
	workerIds: string[];
	contactedAt: Date;
	contactType: ContactType;
	comment?: string;
}

export interface SaveLastContactByCompanyNeedResponse {
	besoinId: string;
	workerIds: string[];
	contactType: ContactType;
	contactedAt: Date;
}

export interface SaveLastContactResponse {
	success: boolean;
}
